module.exports = __webpack_public_path__ + "static/media/gh.5cff78e4.svg";